<script lang="ts">
  import { cva, type VariantProps } from 'class-variance-authority';

  import Icon from './icon/icon.svelte';

  import { cn } from '$lib/utils';

  import type { IconOptions } from './icon/icon.svelte';
  import type { ComponentProps } from 'svelte';

  const badge = cva(
    [
      `
        flex
        items-center

        w-fit
        rounded-xs

        font-semibold

        bg-highlight/80
      `
    ],
    {
      variants: {
        icon: { true: '' },
        size: {
          sm: `
            h-6
            px-2
            text-xs/none
            font-semibold
          `,
          md: `
            h-6.5
            px-2.5
            text-sm/none
          `,
          micro: `
            h-5
            px-1.5
            text-xs/none
            lining-nums
            tabular-nums
          `
        }
      },
      compoundVariants: [
        {
          size: 'sm',
          icon: true,
          class: 'pl-1.5 pr-2'
        },
        {
          size: 'md',
          icon: true,
          class: 'pl-1.5 pr-2.5'
        }
      ]
    }
  );

  let className: string | undefined = undefined;
  export { className as class };

  export let size: VariantProps<typeof badge>['size'] | undefined = 'md';
  export let icon: IconOptions | undefined = undefined;

  const iconSizes: Record<
    NonNullable<VariantProps<typeof badge>['size']>,
    ComponentProps<Icon>['size']
  > = {
    micro: 'sm',
    sm: 'sm',
    md: 'md'
  };
</script>

<div class={cn(badge({ size, icon: !!icon }), className)} {...$$restProps}>
  {#if $$slots.default}
    {#if icon && size}
      <Icon {icon} size={iconSizes[size]} class="mr-1 text-accent" />
    {/if}
    <slot />
  {/if}
</div>
